<template>
  <section v-where-view class="sight-location">
    <h2 class="sight-location__title">{{ t('location.title') }}</h2>
    <p class="sight-location__description">{{ location.description }}</p>
    <div class="sight-location__map">
      <SightMap
        v-if="location.latitude && location.longitude"
        :latitude="location.latitude"
        :longitude="location.longitude"
        :zoom="15"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from '@experience/i18n';

import { useAnalytics } from '@/shared/lib/analytics';
import SightMap from '@/shared/ui/SightMap.vue';

import ru from '../i18n/ru.json';

import type { AttractionLocation } from '../models/attractionCard';

defineProps<{
  location: AttractionLocation;
}>();

const { useViewTracker } = useAnalytics();
const vWhereView = useViewTracker('sight:where.view');

const { t } = useI18n<{ message: typeof ru }, 'ru'>({
  inheritLocale: true,
  messages: { ru },
});
</script>

<style scoped lang="scss">
.sight-location__title {
  margin: 0;

  @include typography.base-800-800-semi;

  @include tablet {
    @include typography.base-700-500-semi;
  }
}

.sight-location__description {
  margin: 8px 0 0;

  @include typography.base-500-400-regular;

  @include tablet {
    @include typography.base-400-400-regular;
  }
}

.sight-location__map {
  width: 100%;
  height: 343px;
  margin-top: var(--alias-space-16, 16px);
  overflow: hidden;
  border-radius: var(--alias-radius-16, 16px);
}
</style>
